/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCustomFieldsDto } from './GetCustomFieldsDto';
import {
    GetCustomFieldsDtoFromJSON,
    GetCustomFieldsDtoFromJSONTyped,
    GetCustomFieldsDtoToJSON,
} from './GetCustomFieldsDto';
import type { GetBatteryDto } from './GetBatteryDto';
import {
    GetBatteryDtoFromJSON,
    GetBatteryDtoFromJSONTyped,
    GetBatteryDtoToJSON,
} from './GetBatteryDto';
import type { GetExamTypeCategoryDto } from './GetExamTypeCategoryDto';
import {
    GetExamTypeCategoryDtoFromJSON,
    GetExamTypeCategoryDtoFromJSONTyped,
    GetExamTypeCategoryDtoToJSON,
} from './GetExamTypeCategoryDto';

/**
 * 
 * @export
 * @interface GetExamTypeDto
 */
export interface GetExamTypeDto {
    /**
     * 
     * @type {string}
     * @memberof GetExamTypeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetExamTypeDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamTypeDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamTypeDto
     */
    importantNote?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamTypeDto
     */
    popular?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamTypeDto
     */
    price?: string | null;
    /**
     * 
     * @type {GetBatteryDto}
     * @memberof GetExamTypeDto
     */
    battery?: GetBatteryDto | null;
    /**
     * 
     * @type {GetExamTypeCategoryDto}
     * @memberof GetExamTypeDto
     */
    category?: GetExamTypeCategoryDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamTypeDto
     */
    online?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamTypeDto
     */
    onlinePayment?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamTypeDto
     */
    selectHarmfulFactors?: boolean | null;
    /**
     * 
     * @type {GetCustomFieldsDto}
     * @memberof GetExamTypeDto
     */
    customFields?: GetCustomFieldsDto | null;
}

/**
 * Check if a given object implements the GetExamTypeDto interface.
 */
export function instanceOfGetExamTypeDto(value: object): value is GetExamTypeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetExamTypeDtoFromJSON(json: any): GetExamTypeDto {
    return GetExamTypeDtoFromJSONTyped(json, false);
}

export function GetExamTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExamTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'importantNote': json['importantNote'] == null ? undefined : json['importantNote'],
        'popular': json['popular'] == null ? undefined : json['popular'],
        'price': json['price'] == null ? undefined : json['price'],
        'battery': json['battery'] == null ? undefined : GetBatteryDtoFromJSON(json['battery']),
        'category': json['category'] == null ? undefined : GetExamTypeCategoryDtoFromJSON(json['category']),
        'online': json['online'] == null ? undefined : json['online'],
        'onlinePayment': json['onlinePayment'] == null ? undefined : json['onlinePayment'],
        'selectHarmfulFactors': json['selectHarmfulFactors'] == null ? undefined : json['selectHarmfulFactors'],
        'customFields': json['customFields'] == null ? undefined : GetCustomFieldsDtoFromJSON(json['customFields']),
    };
}

export function GetExamTypeDtoToJSON(value?: GetExamTypeDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'importantNote': value['importantNote'],
        'popular': value['popular'],
        'price': value['price'],
        'battery': GetBatteryDtoToJSON(value['battery']),
        'category': GetExamTypeCategoryDtoToJSON(value['category']),
        'online': value['online'],
        'onlinePayment': value['onlinePayment'],
        'selectHarmfulFactors': value['selectHarmfulFactors'],
        'customFields': GetCustomFieldsDtoToJSON(value['customFields']),
    };
}

